import React from "react";
import "./App.css";
import AgeVerification from "./components/AgeVerification";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import ProductsSection from "./components/ProductsSection";
import GallerySection from "./components/GallerySection";
import VisitSection from "./components/VisitSection";
import ContactSection from "./components/ContactSection";
import FloatingWhatsApp from "./components/FloatingWhatsApp";
import { storeInfo } from "./data/mockData";
import { Instagram, Facebook } from "lucide-react";

const Footer = () => (
  <footer className="bg-[#050505] border-t border-[#1a1a1a] py-10">
    <div className="max-w-7xl mx-auto px-6">
      <div className="flex flex-col md:flex-row items-center justify-between gap-4">
        <div>
          <span className="text-[#c8ff00] font-bold text-lg">Stayfly Smokers</span>
          <p className="text-gray-500 text-sm mt-1">Premium Vape &amp; Smoke Shop, Roodepoort</p>
        </div>
        <div className="flex items-center gap-4">
          <a
            href={storeInfo.contact.instagram}
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-500 hover:text-[#c8ff00] transition-colors"
            aria-label="Instagram"
          >
            <Instagram size={18} />
          </a>
          <a
            href={storeInfo.contact.facebook}
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-500 hover:text-[#c8ff00] transition-colors"
            aria-label="Facebook"
          >
            <Facebook size={18} />
          </a>
        </div>
        <p className="text-gray-600 text-xs">
          &copy; {new Date().getFullYear()} Stayfly Smokers. All rights reserved.
        </p>
      </div>
    </div>
  </footer>
);

function App() {
  return (
    <div className="App bg-[#0a0a0a] min-h-screen">
      <AgeVerification />
      <Navbar />
      <HeroSection />
      <AboutSection />
      <ProductsSection />
      <GallerySection />
      <VisitSection />
      <ContactSection />
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}

export default App;
